import { RadialGradient } from '@jouzen/ecom-components';

import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

const BackgroundOverlay = (): JSX.Element => (
  <div className="absolute top-0 size-full">
    <div className="absolute top-0 size-full lg:hidden">
      <RadialGradient
        className="scale-x-150"
        hex="#000000"
        id="mobile-gradient-1"
        opacity={0.65}
        position={[50, 0]}
        size={60}
        shape="circle"
      />
      <RadialGradient
        className="scale-x-150"
        hex="#321F16"
        id="mobile-gradient-2"
        opacity={0.65}
        position={[50, 100]}
        size={50}
        shape="circle"
      />
    </div>
    <div className="absolute top-0 size-full max-lg:hidden">
      <RadialGradient
        hex="#321F16"
        id="desktop-gradient-1"
        opacity={0.8}
        position={[20, 100]}
        size={40}
        shape="circle"
      />
      <RadialGradient
        hex="#0C0C0C"
        id="desktop-gradient-2"
        opacity={0.25}
        position={[0, 50]}
        size={60}
        shape="circle"
      />
      <RadialGradient
        hex="#0C0C0C"
        id="desktop-gradient-3"
        opacity={0.25}
        position={[10, 50]}
        size={60}
        shape="circle"
      />
    </div>
  </div>
);

const ScienceAndResearchHeroOR4 = (): JSX.Element => {
  return (
    <LandingPageHero
      backgroundImage={{
        localizedAlt: 'science_and_research_hero_alt',
        srcSet: [
          {
            media: '(max-width: 1023px)',
            src: '/blue-sky/science-and-research/science-research-hero-10-24.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.6&fp-y=0.5&fp-z=1',
          },
          {
            media: '(min-width: 1024px)',
            src: '/blue-sky/science-and-research/science-research-hero-10-24.jpg?ar=5:4&fit=crop&crop=focalpoint&fp-x=0.43&fp-y=0.65&fp-z=1.1',
          },
        ],
      }}
      backgroundOverlay={<BackgroundOverlay />}
      backgroundProps={{
        color: 'sandstone-400',
        gradients: [],
      }}
      copy="science_and_research_hero_description"
      data-cy="science-and-research-hero-or4"
      eyebrow="science_and_research_hero_eyebrow"
      title="science_and_research_hero_title"
      textColor="text-sandstone-200"
    />
  );
};

export default ScienceAndResearchHeroOR4;
